import { render, staticRenderFns } from "./reply-memo.vue?vue&type=template&id=212d1b1c&scoped=true&"
import script from "./reply-memo.vue?vue&type=script&lang=js&"
export * from "./reply-memo.vue?vue&type=script&lang=js&"
import style0 from "./reply-memo.vue?vue&type=style&index=0&id=212d1b1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212d1b1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
